export default __webpack_public_path__ + "img/4acdc6e142513e177cf07c1b817e4a4a.svg";